import React, { useState } from 'react';
import { FaCaretUp, FaCaretDown } from 'react-icons/fa';
import PersonalInfo from 'pages/private/Profile/PersonalInfo';
import Account from 'pages/private/Profile/Account';
import Helmet from 'components/Helmet';
import useOutsideClickHandler from 'hooks/useOutsideClickHandler';
import './index.css';

function Profile() {
    const [menu, setMenu] = useState(0);
    const [dropdown, setDropdown] = useState(false);

    const dropdownRef = useOutsideClickHandler(() => setTimeout(() => setDropdown(false), 10));

    const menus = {
        'My Profile': <PersonalInfo />,
        'Account Type': <Account />,
        // 'Test Result': null,
        // 'Course History': null,
        // 'Payment History': null,
        // 'Notifications': null
    };

    return (
        <div className='layout'>
            <Helmet
                title='My Profile | PrepSharp Students'
            />
            <div className='profile'>
                <div className='profile__menu'>
                    {Object.keys(menus).map((key, i) => (
                        <p
                            key={key}
                            className={menu === i
                                ? 'profile__menuItem--active'
                                : 'profile__menuItem'
                            }
                            onClick={() => setMenu(i)}
                        >
                            {key}
                        </p>
                    ))}
                </div>
                <button
                    className='profile__dropdown'
                    onClick={() => setDropdown(!dropdown)}
                    ref={dropdownRef}
                >
                    {Object.keys(menus)[menu]}
                    {dropdown
                        ? <FaCaretUp className='profile__dropdownIcon' />
                        : <FaCaretDown className='profile__dropdownIcon' />
                    }
                    {dropdown &&
                        <div className='profile__dropdownMenu'>
                            {Object.keys(menus).map((key, i) => (
                                <p
                                    key={key}
                                    className={menu === i
                                        ? 'profile__dropdownMenuItem--active'
                                        : 'profile__dropdownMenuItem'
                                    }
                                    onClick={() => setMenu(i)}
                                >
                                    {key}
                                </p>
                            ))}
                        </div>
                    }
                </button>
                {menus[Object.keys(menus)[menu]]}
            </div>
        </div>
    );
}

export default Profile;